import axios from 'axios';
window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Error handling for axios requests
axios.interceptors.response.use(response => response, async err => {
    if (err.status === 419) {
        // Refresh our session token
        await axios.get('/csrf-token')

        // Return a new request using the original request's configuration
        return axios(err.response.config)
    }

    if (err.status === 401) {
        // Redirect to login page
        window.location.href = '/login'
    }

    return Promise.reject(err)
})

// Add a listener for negative y scroll
// This is added to refresh the page when the user pulls down
// This should work normally but this fixes the issues of 
// an app added to the home screen on iOS not refreshing properly
if (window.matchMedia('(display-mode: standalone)').matches) {
    window.addEventListener('scroll', function () {
        if (window.scrollY < -75) {
            window.location.reload();
        }
    });
}
/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allow your team to quickly build robust real-time web applications.
 */

import './echo';
